import { AiToolImpl } from "@me8eon/aiclient";
import { WidgetMeta } from "@me8eon/ai.tools.utils/src/widget";

type ToolArgs = Record<string, never>;
type ToolImpl = AiToolImpl<ToolArgs>;
type Tool = () => ToolImpl;

export const DisplayLiveAgentChatActionToolImpl: Tool = () => {
    return {
        type: "service_api",
        toolDefn: {
            type: "function",
            name: "display_live_agent_chat_action",
            description:
                "This tool displays a live agent chat widget for ServiceNow. Here user can connect with a live agent.",
            parameters: {
                type: "object",
                properties: {},
                required: [],
                additionalProperties: false,
            }
        },
        execute: async (_options, _args) => {
            const widgetMeta: WidgetMeta = {
                name: "live_agent_chat_widget",
                title: "Live Agent Chat in ServiceNow",
                description: "Displays a widget to connect with live agent in ServiceNow",
                type: "widget",
                componentName: "LiveAgentChatActionWidget",
                props: {}
            };

            return {
                _meta: {
                    widget: widgetMeta,
                    skipAiSummary: true
                },
                value: "Displaying Live Agent Chat Widget"
            };
        }
    };
};